import { Outlet } from "@tanstack/react-router";
import { Brand } from "../../ui";
import { tokenStorage } from "../../../utils/tokenStorage";

export function AuthLayout() {
  const year = new Date().getFullYear();
  const brandTo = tokenStorage.getAccessToken() ? "/app" : "/";

  return (
    <main className="auth-layout min-h-dvh">
      <div className="min-h-dvh w-full lg:grid lg:grid-cols-2">
        <section className="flex min-h-dvh flex-col px-6 pb-12 pt-8 sm:px-12 sm:pt-10 lg:px-16 xl:px-20 2xl:px-24">
          <div className="flex h-[--navbar-height] items-start">
            <Brand className="text-foreground" to={brandTo} />
          </div>
          <div className="flex flex-1 flex-col">
            <div className="my-auto w-full">
              <Outlet />
            </div>
          </div>
        </section>
        <div
          className="relative hidden overflow-hidden bg-muted lg:block"
          style={{
            backgroundImage: "url('/image.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0 bg-black/40" />
          <div className="pointer-events-none absolute bottom-4 right-6 text-xs text-white/80">
            {year} Fundy - All Rights Reserved
          </div>
        </div>
      </div>
    </main>
  );
}
